<!--
  - Copyright (c) 2019. K+S France & Isagri Ingénierie
  - Ce composant est la vue qui gère l'affichage des recommandations
  - SD version du 30/08/2019 16:05:31
  -->

<template>
  <div class="recommandation">
    <h1 class="form-title">Préconisation</h1>
    <!--<div class="tar mb-4">
      <div class="dib mr-2">{{ $t("preco_ab") }}</div>
      <div class="dib">
        <v-switch
          v-model="ab"
          @change="switchAb"
          color="primary"
          class="switch2e"
        ></v-switch>
      </div>
    </div>-->
    <div class="graph__wrapper">
      <div class="helpIcon">
        <a href="#/aide/1029">
          <v-icon large color="primary">info</v-icon>
        </a>
      </div>
      <div class="graphSVG">
        <div id="labelNeads" v-html="$options.filters.capitalize($t('synthesis_neads'))"></div>
        <div
          id="labelContribution"
          v-html="$options.filters.capitalize($t('synthesis_contributions'))"
        ></div>
        <div id="labelApportsM" v-html="$t('preco_apportsM')"></div>
        <div class="elem__neads">
          <div class="elem__k2o">{{ neads.k2o | intLocal }}</div>
          <div class="elem__mgo">{{ neads.mgo | intLocal }}</div>
          <div class="elem__so3">{{ neads.so3 | intLocal }}</div>
        </div>
        <svg version="1.1" id="barrique" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 461 472" enable-background="new 0 0 461 472" xml:space="preserve">
<ellipse id="fuite" fill-rule="evenodd" clip-rule="evenodd" fill="#C6E9FF" cx="230.5" cy="350.2" rx="164" ry="66"/>
          <g id="arrieredroit_1_" enable-background="new    ">
	<g>
		<polygon fill="#D6B173" points="261.6,4.7 261.6,287.2 259.5,292 259.5,9.5 		"/>
	</g>
            <g>
		<polygon fill="#C7B299" points="289.8,20.4 289.8,290.3 285.7,294.8 285.7,25 		"/>
	</g>
            <g>
		<polygon fill="#D6B173" points="316.3,19.7 316.3,297.4 310.3,301.7 310.3,23.9 		"/>
	</g>
            <path fill="#F9E5B1" d="M289.8,14.7c-9.1-1.3-18.5-2.4-28.2-3.1l-2.1,4.8c9,0.6,17.8,1.6,26.2,2.8c8.6,1.3,16.8,2.8,24.6,4.7l6-4.2
		C307.9,17.7,299,16.1,289.8,14.7z"/>
            <path fill="#EFC681" d="M332.5,43.5c-6.9-2.4-14.3-4.5-22.2-6.3v262.4c7.9,1.9,15.3,4,22.2,6.3c6.9,2.4,13.3,5,19.2,7.8V51.3
		C345.8,48.4,339.4,45.8,332.5,43.5z"/>
            <path fill="#F9E5B1" d="M340.2,39.7c-7.4-2.5-15.4-4.8-23.9-6.8l-6,4.2c7.9,1.9,15.3,4,22.2,6.3c6.9,2.4,13.3,5,19.2,7.8l9.2-3.1
		C354.6,45.1,347.7,42.3,340.2,39.7z"/>
            <path fill="#EFC681" d="M367.2,48.6c-4.5-3.2-9.8-6.2-15.6-9v274.1c5.8,2.8,11,5.8,15.6,9c4.5,3.2,8.4,6.5,11.5,10V58.6
		C375.6,55.1,371.8,51.8,367.2,48.6z"/>
            <path fill="#F9E5B1" d="M377.6,46.2c-4.9-3.4-10.5-6.7-16.8-9.7l-9.2,3.1c5.8,2.8,11,5.8,15.6,9c4.5,3.2,8.4,6.5,11.5,10l11.2-1.7
		C386.6,53.2,382.5,49.6,377.6,46.2z"/>
            <g>
		<rect x="388.1" y="69.9" fill="#E0BA79" width="12" height="284.4"/>
	</g>
            <path fill="#F9E5B1" d="M397.5,58.1c-1.7-4-4.2-7.8-7.5-11.5l-11.2,1.7c3.1,3.4,5.4,7,7,10.7c1.5,3.6,2.3,7.2,2.3,11h12
		C400,65.9,399.2,61.9,397.5,58.1z"/>
            <path fill="#EFC681" d="M385.7,58.9c-1.6-3.7-3.9-7.2-7-10.7v284.4c3.1,3.4,5.4,7,7,10.7c1.5,3.6,2.3,7.2,2.3,11V69.9
		C388.1,66.2,387.3,62.5,385.7,58.9z"/>
            <path fill="#EFC681" d="M285.7,19.3L285.7,19.3c-8.4-1.3-17.2-2.2-26.2-2.9v269.9c9,0.6,17.8,1.6,26.2,2.8v5.7
		c8.6,1.3,16.8,2.8,24.6,4.7V24C302.5,22.1,294.3,20.6,285.7,19.3z"/>
</g>
          <g id="arrieregauche_1_" enable-background="new    ">
	<path fill="#F9E5B1" d="M232.5,3.7L232.5,3.7c-9.9,0-19.6,0.4-29.1,1l2.1,4.8c8.8-0.6,17.8-1,27-1v0c9.2,0,18.2,0.3,27,1l2.1-4.8
		C252.1,4.1,242.4,3.7,232.5,3.7z"/>
            <path fill="#EFC681" d="M232.5,8.6L232.5,8.6c-9.2,0-18.2,0.3-27,1V292c8.8-0.6,17.8-1,27-1s18.2,0.3,27,1V9.5
		C250.7,8.9,241.7,8.6,232.5,8.6z"/>
            <g>
		<polygon fill="#C1A271" points="205.5,9.5 205.5,292 203.4,287.2 203.4,4.7 		"/>
	</g>
            <path fill="#EFC681" d="M179.3,27.2c-8.6,1.3-18,1.4-25.8,3.2l0.2,269.4c7.8-1.8,17.1-3.7,25.7-4.9c8.4-1.2,17.2-2.2,26.2-2.8V24.4
		C196.5,25,187.7,26,179.3,27.2z"/>
            <path fill="#F9E5B1" d="M203.4,19.6c-9.7,0.7-19.2,1.7-28.2,3.1c-9.2,1.4-18.1,3.1-26.5,5l6,4.2c7.8-1.8,16-3.4,24.6-4.7
		c8.4-1.2,17.2-2.2,26.2-2.8L203.4,19.6z"/>
            <g>
		<path fill="#EFC681" d="M154.7,12.1L153,301c-6.2,0.4-13.6,2.5-20.5,4.9V18.5C139.4,16.1,148.5,12.5,154.7,12.1z"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M154.7,12.1c-7.9,1.9-15.3,4-22.2,6.3l-7.7-3.7c7.5-2.5,15.4-4.8,23.9-6.8L154.7,12.1z"/>
	</g>
            <g>
		<polygon fill="#D6B173" points="113.3,26.2 113.3,313.6 104.2,310.5 104.2,23.1 		"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M132.5,18.5c-6.9,2.4-13.3,5-19.2,7.8l-9.2-3.1c6.3-3,13.2-5.8,20.6-8.4L132.5,18.5z"/>
	</g>
            <g>
		<path fill="#EFC681" d="M132.5,18.5l0,287.4c-6.9,2.4-13.3,5-19.2,7.8V26.3C119.2,23.5,125.6,20.8,132.5,18.5z"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M113.3,34.7c-5.8,2.8-11,5.8-15.6,9l-10.4-2.4c4.9-3.4,10.5-6.7,16.8-9.7L113.3,34.7z"/>
	</g>
            <g>
		<polygon fill="#C7B299" points="97.8,48.6 97.8,322.7 87.4,320.2 87.4,46.2 		"/>
	</g>
            <g>
		<path fill="#EFC681" d="M113.3,34.7l0,279c-5.8,2.8-11,5.8-15.6,9v-279C102.3,40.5,107.5,37.5,113.3,34.7z"/>
	</g>
            <g>
		<path fill="#EFC681" d="M97.8,43.7l0,279c-4.5,3.2-8.4,6.5-11.5,10v-279C89.4,50.2,93.2,46.9,97.8,43.7z"/>
	</g>
            <g>
		<polygon fill="#D6B173" points="86.3,53.7 86.3,332.7 75,331 75,52 		"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M97.8,43.7c-4.5,3.2-8.4,6.5-11.5,10L75,52c3.4-3.8,7.5-7.4,12.4-10.8L97.8,43.7z"/>
	</g>
            <g>
		<rect x="65" y="82.7" fill="#C7B299" width="12" height="271.6"/>
	</g>
            <path fill="#EFC681" d="M79.3,69.3c-1.5,3.6-2.3,7.2-2.3,11v274.1c0-3.7,0.8-7.4,2.3-11c1.6-3.7,3.9-7.2,7-10.7V58.6
		C83.2,62,80.8,65.6,79.3,69.3z"/>
            <path fill="#F9E5B1" d="M75,56.9c-3.3,3.7-5.8,7.5-7.5,11.5c-1.6,3.8-2.5,7.8-2.5,11.8h12c0-3.7,0.8-7.4,2.3-11
		c1.6-3.7,3.9-7.2,7-10.7L75,56.9z"/>
</g>
          <g id="eau_1_">
	<polygon fill="#C6E9FF" points="86.3,101.9 86.3,376 75,377.6 75,103.6 	"/>
            <path fill="#C6E9FF" d="M232.5,65.3c-90.6,0-164,29.5-164,66v227h0.1c2.6,35.5,75,64,163.9,64s161.3-28.5,163.9-64h0.1v-227
		C396.5,94.8,323.1,65.3,232.5,65.3z"/>
</g>
          <g id="devantgauche_2_">
	<g>
		<polygon fill="#D6B173" points="86.3,96.5 86.8,376.8 75,377.6 75,98.2 		"/>
	</g>
            <path fill="#F9E5B1" d="M79.3,85.9c-1.5-3.6-2.3-7.2-2.3-11H65c0,4,0.9,8,2.5,11.8c1.7,4,4.2,7.8,7.5,11.5l11.3-1.7
		C83.2,93.1,80.8,89.5,79.3,85.9z"/>
            <path fill="#C1A271" d="M67.5,86.7c-1.6-3.8-2.5-7.8-2.5-11.8v279.4c0,4,0.9,8,2.5,11.8c1.7,4,4.2,7.8,7.5,11.5V98.2
		C71.7,94.5,69.2,90.7,67.5,86.7z"/>
            <g>
		<path fill="#F9E5B1" d="M97.8,114.7c-4.5-3.2-8.4-6.5-11.5-10L75,106.4c3.4,3.8,7.5,7.4,12.4,10.8L97.8,114.7z"/>
              <path fill="#F9E5B1" d="M97.8,114.8l-10.4,2.4c4.9,3.4,10.5,6.7,16.8,9.7l9.2-3.1C107.5,121,102.3,118,97.8,114.8z"/>
	</g>
            <path fill="#C1A271" d="M87.4,117.2L87.4,117.2c-4.9-3.4-9-7-12.4-10.8v271.2c3.4,3.8,7.5,7.4,12.4,10.8c4.9,3.4,10.5,6.7,16.8,9.7
		V126.9C97.9,123.9,92.3,120.6,87.4,117.2z"/>
            <g>
		<polygon fill="#C7B299" points="132.5,126.7 132.5,402.8 124.8,406.5 124.8,130.4 		"/>
	</g>
            <g>
		<polygon fill="#EFC681" points="154.7,126.9 154.7,409.1 148.7,413.3 148.7,131.1 		"/>
	</g>
            <path fill="#F9E5B1" d="M132.5,120.5c-6.9-2.4-13.3-5-19.2-7.8l-9.2,3.1c6.3,3,13.2,5.8,20.6,8.4c7.5,2.5,15.4,4.8,23.9,6.8l6-4.2
		C146.8,125,139.4,122.9,132.5,120.5z"/>
            <path fill="#C1A271" d="M124.8,124.3L124.8,124.3c-7.5-2.6-14.4-5.4-20.6-8.4v282.2c6.3,3,13.2,5.8,20.6,8.4
		c7.5,2.5,15.4,4.8,23.9,6.8V131.1C140.3,129.1,132.3,126.8,124.8,124.3z"/>
</g>
          <polygon fill="#D6B173" points="154.6,30.2 156.4,31.5 154.9,73.2 154.6,31.7 "/>
          <polyline fill="#D6B173" points="112.8,34.9 113.3,85.9 113.3,34.7 104.2,31.5 "/>
          <polygon fill="#D6B173" points="75,56.9 86.1,58.8 87.4,100.5 86.3,58.6 "/>
          <polygon fill="#C1A271" points="203.4,19.6 205,24.3 205.3,66.2 205.5,24.4 "/>
          <polygon fill="#D6B173" points="75,100.2 75,183.6 75.4,100.6 "/>
          <polygon fill="#D6B173" points="104.2,126.2 103.4,126.6 104.2,366.7 104.2,126.9 "/>
          <polygon fill="#D6B173" points="261.6,11.6 259.5,16.4 259.5,66.2 260.4,16.3 "/>
          <polygon fill="#D6B173" points="311.7,22.8 310.3,23.9 310.3,73.2 310.7,24 "/>
          <polygon fill="#D6B173" points="351.7,50.1 350.7,50.8 351.7,85.9 351.7,51.3 "/>
          <polygon fill="#D6B173" points="378.7,57.7 378.2,58 378.7,101.9 378.7,58.6 "/>
          <g id="devantdroit_1_">
	<g>
		<polygon fill="#E8D0B2" points="397.5,92.1 397.5,366.1 385.7,365.3 385.7,91.2 		"/>
	</g>
            <path fill="#EFC681" d="M397.5,92.1c-1.7,4-4.2,7.8-7.5,11.5v274.1c3.3-3.7,5.8-7.5,7.5-11.5c1.7-3.8,2.5-7.8,2.5-11.8V80.2
		C400,84.3,399.2,88.2,397.5,92.1z"/>
            <path fill="#F9E5B1" d="M388.1,80.2c0,3.7-0.8,7.4-2.3,11c-1.6,3.7-3.9,7.2-7,10.7l11.2,1.7c3.3-3.7,5.8-7.5,7.5-11.5
		c1.7-3.8,2.5-7.8,2.5-11.8H388.1z"/>
            <g>
		<polygon fill="#E0BA79" points="390,103.6 389.1,378.4 378.7,376 378.7,101.9 		"/>
	</g>
            <g>
		<polygon fill="#C1A271" points="360.8,137 360.8,398.1 351.7,395 351.7,133.9 		"/>
	</g>
            <path fill="#F9E5B1" d="M378.7,109.7c-3.1,3.5-7,6.8-11.5,10c-4.5,3.2-9.8,6.3-15.6,9.1l9.2,3.1c6.3-3,11.9-6.4,16.8-9.8
		c4.9-3.4,9-7,12.4-10.8L378.7,109.7z"/>
            <g>
		<path fill="#EFC681" d="M360.8,128l0,270.2c-6.3,3-13.2,5.8-20.7,8.4l0-270.2C347.7,133.8,354.6,131,360.8,128z"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M360.8,128c-6.3,3-13.2,5.8-20.7,8.4l-7.7-3.7c6.9-2.4,13.3-5,19.2-7.8L360.8,128z"/>
	</g>
            <g>
		<polygon fill="#C1A271" points="328,140 328.1,410.8 322,406.5 322,135.8 		"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M340.2,136.4c-7.4,2.5-9.7,3.1-12.2,3.7l-6-4.2c2.9-0.7,3.6-0.8,10.5-3.2L340.2,136.4z"/>
	</g>
            <g>
		<path fill="#EFC681" d="M340.2,136.4l0,270.2c-3.8,1.3-6,2.2-12,4.3L328,140C332.4,139,332.9,138.7,340.2,136.4z"/>
	</g>
            <path fill="#EFC681" d="M377.6,122.1c-4.9,3.4-10.5,6.8-16.8,9.8v266.2c6.3-3,11.9-6.3,16.8-9.7c4.9-3.4,9-7,12.4-10.8V111.4
		C386.6,115.1,382.5,118.7,377.6,122.1z"/>
</g>
          <polygon fill="#E0BA79" points="397.5,91.5 397.7,91.8 397.7,185.7 397.5,93.3 "/>
          <polygon fill="#E0BA79" points="378.7,101.9 390,103.6 390,242.4 389.4,104.2 "/>
          <polygon fill="#C1A271" points="361.2,131.8 361.4,364.2 360.8,132 "/>
          <path id="cerclage" fill="#423329" d="M397.6,121.7c-1.9,4.2-4.4,8.1-7.5,11.5c-3.7,4-7.9,7.7-12.4,10.8c-5.3,3.7-10.9,6.9-16.8,9.7
	c-6.7,3.2-13.6,6-20.6,8.4c-7.5,2.5-15.4,4.8-23.9,6.8c-8.4,2-17.2,3.7-26.5,5c-9.1,1.3-18.5,2.4-28.2,3.1c-9.5,0.7-19.2,1-29.1,1
	c-9.9,0-19.6-0.4-29.1-1c-9.7-0.7-19.2-1.7-28.2-3.1c-9.2-1.4-18.1-3.1-26.5-5c-8.5-2-16.5-4.3-23.9-6.8c-7-2.4-13.9-5.2-20.6-8.4
	c-5.8-2.8-11.5-6-16.8-9.7c-4.5-3.1-8.7-6.7-12.4-10.8c-3.1-3.4-5.7-7.3-7.5-11.5c-1.6-3.7-2.5-7.8-2.5-11.8V140
	c0,4.1,0.9,8.1,2.5,11.8c1.9,4.2,4.4,8.1,7.5,11.5c3.7,4,7.9,7.7,12.4,10.8c5.3,3.7,10.9,6.9,16.8,9.7c6.7,3.2,13.6,6,20.6,8.4
	c7.5,2.5,15.4,4.8,23.9,6.8c8.4,2,17.2,3.7,26.5,5c9.1,1.3,18.5,2.4,28.2,3.1c9.5,0.7,19.2,1,29.1,1c9.9,0,19.6-0.4,29.1-1
	c9.7-0.7,19.2-1.7,28.2-3.1c9.2-1.4,18.1-3.1,26.5-5c8.5-2,16.5-4.3,23.9-6.8c7-2.4,13.9-5.2,20.6-8.4c5.8-2.8,11.5-6,16.8-9.7
	c4.5-3.1,8.7-6.7,12.4-10.8c3.1-3.4,5.7-7.3,7.5-11.5c1.6-3.7,2.5-7.8,2.5-11.8v-30.2C400.1,113.9,399.2,117.9,397.6,121.7z"/>
</svg>
      </div>
      <div class="slides">
        <div class="k2o">
          <vue-slider
            v-if="enable_k2o"
            :disabled="disable_k2o"
            v-bind="options_slides"
            v-model="m_k2o"
            :max="max_k2o"
            :min="min_k2o"
            :height="h_k2o"
            @change="slideChange"
            :style="{ padding: 0, bottom: decal_k2o + 'px' }"
          >
            <template v-slot:dot="{ value, focus }">
              <span class="curseur_value">
                <span
                  class="value_elem"
                  v-html="intSup(value - apports.k2o)"
                ></span>
                <svg id="Calque_2" class="curseur" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 316.01 401.03">
                  <g id="Layer_1" data-name="Layer 1">
                    <path class="cls-1" d="m284.73,267.95l26.48-40.52c8.91-13.63,5.04-32.08-8.59-40.99h0c-13.63-8.91-28.42-4.28-37.33,9.36l-14.22,20.46c-.74-.81-3.49-2.62-4.25-3.43,5.1-7.74,9.67-13.45,12.21-17.34l13.59-20.8c8.91-13.63,7.04-32.08-6.59-40.99h0c-13.63-8.91-30.08-5.04-38.99,8.59l-13.59,20.8c-2.16,3.31-5.53,8.79-9.2,13.8-.33-.22-4.66-3.44-4.99-3.65,1.78-1.63,2.39-3.5,3.76-5.61l32.57-48.31c8.91-13.63,7.04-30.08-6.59-38.99l-2-1c-13.63-8.91-30.08-3.04-38.99,10.59l-24.5,37.49-4.72-2.93,53.08-80.69c8.91-13.63,6.04-31.08-7.59-39.99l2,1c-13.63-8.91-32.08-5.04-40.99,8.59l-70.21,107.43c-12.89,16.93-20.89,29.55-32.51,42.39l-3.42-53.41c-1.04-16.25-15.19-28.7-31.44-27.66h0C11.47,83.17-.98,97.32.06,113.57l10.38,162.25c.18,2.79.75,5.46,1.64,7.98,1.95,38.12,21.39,74.89,55.6,97.25h0c56.81,37.12,133.66,21.02,170.79-35.79l20.86-31.92,25.4-45.38Z" />
                  </g>
                </svg>
              </span>
            </template>
          </vue-slider>
          <div class="elem__graph" :style="{ marginBottom: compense_k2o }">
            <div
              :class="{ elem__value: true, 'c-k-l': true, 't-black': h_k < 16 }"
              :style="{ height: h_k + 'px' }"
            >
              {{ apports.k2o | intLocal }}
            </div>
          </div>
          <div class="elem__label" v-html="$t('k2o')"></div>
        </div>
        <!--k2o-->
        <div class="mgo">
          <vue-slider
            v-if="enable_mgo"
            :disabled="disable_mgo"
            v-model="m_mgo"
            v-bind="options_slides"
            :min="min_mgo"
            :max="max_mgo"
            :height="h_mgo"
            @change="slideChange"
            :style="{ padding: 0, bottom: decal_mgo + 'px' }"
          >
            <template v-slot:dot="{ value, focus }">
              <span class="curseur_value">
                <span
                  class="value_elem"
                  v-html="intSup(value - apports.mgo)"
                ></span>
                <svg id="Calque_2" class="curseur" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 316.01 401.03">
                  <g id="Layer_1" data-name="Layer 1">
                    <path class="cls-1" d="m284.73,267.95l26.48-40.52c8.91-13.63,5.04-32.08-8.59-40.99h0c-13.63-8.91-28.42-4.28-37.33,9.36l-14.22,20.46c-.74-.81-3.49-2.62-4.25-3.43,5.1-7.74,9.67-13.45,12.21-17.34l13.59-20.8c8.91-13.63,7.04-32.08-6.59-40.99h0c-13.63-8.91-30.08-5.04-38.99,8.59l-13.59,20.8c-2.16,3.31-5.53,8.79-9.2,13.8-.33-.22-4.66-3.44-4.99-3.65,1.78-1.63,2.39-3.5,3.76-5.61l32.57-48.31c8.91-13.63,7.04-30.08-6.59-38.99l-2-1c-13.63-8.91-30.08-3.04-38.99,10.59l-24.5,37.49-4.72-2.93,53.08-80.69c8.91-13.63,6.04-31.08-7.59-39.99l2,1c-13.63-8.91-32.08-5.04-40.99,8.59l-70.21,107.43c-12.89,16.93-20.89,29.55-32.51,42.39l-3.42-53.41c-1.04-16.25-15.19-28.7-31.44-27.66h0C11.47,83.17-.98,97.32.06,113.57l10.38,162.25c.18,2.79.75,5.46,1.64,7.98,1.95,38.12,21.39,74.89,55.6,97.25h0c56.81,37.12,133.66,21.02,170.79-35.79l20.86-31.92,25.4-45.38Z" />
                  </g>
                </svg>
              </span>
            </template>
          </vue-slider>
          <div class="elem__graph" :style="{ marginBottom: compense_mgo }">
            <div
              :class="{ elem__value: true, 'c-m-l': true, 't-black': h_m < 5 }"
              :style="{ height: h_m + 'px' }"
            >
              {{ apports.mgo | intLocal }}
            </div>
          </div>
          <div class="elem__label" v-html="$t('mgo')"></div>
        </div>
        <!--mgo-->
        <div class="so3">
          <vue-slider
            v-if="enable_so3"
            :disabled="disable_so3"
            v-model="m_so3"
            v-bind="options_slides"
            :min="min_so3"
            :max="max_so3"
            :height="h_so3"
            @change="slideChange"
            :style="{ padding: 0, bottom: decal_so3 + 'px' }"
          >
            <template v-slot:dot="{ value, focus }">
              <span class="curseur_value">
                <span
                  class="value_elem"
                  v-html="intSup(value - apports.so3)"
                ></span>
                <svg id="Calque_2" class="curseur" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 316.01 401.03">
                  <g id="Layer_1" data-name="Layer 1">
                     <path class="cls-1" d="m284.73,267.95l26.48-40.52c8.91-13.63,5.04-32.08-8.59-40.99h0c-13.63-8.91-28.42-4.28-37.33,9.36l-14.22,20.46c-.74-.81-3.49-2.62-4.25-3.43,5.1-7.74,9.67-13.45,12.21-17.34l13.59-20.8c8.91-13.63,7.04-32.08-6.59-40.99h0c-13.63-8.91-30.08-5.04-38.99,8.59l-13.59,20.8c-2.16,3.31-5.53,8.79-9.2,13.8-.33-.22-4.66-3.44-4.99-3.65,1.78-1.63,2.39-3.5,3.76-5.61l32.57-48.31c8.91-13.63,7.04-30.08-6.59-38.99l-2-1c-13.63-8.91-30.08-3.04-38.99,10.59l-24.5,37.49-4.72-2.93,53.08-80.69c8.91-13.63,6.04-31.08-7.59-39.99l2,1c-13.63-8.91-32.08-5.04-40.99,8.59l-70.21,107.43c-12.89,16.93-20.89,29.55-32.51,42.39l-3.42-53.41c-1.04-16.25-15.19-28.7-31.44-27.66h0C11.47,83.17-.98,97.32.06,113.57l10.38,162.25c.18,2.79.75,5.46,1.64,7.98,1.95,38.12,21.39,74.89,55.6,97.25h0c56.81,37.12,133.66,21.02,170.79-35.79l20.86-31.92,25.4-45.38Z" />
                  </g>
                </svg>
              </span>
            </template>
          </vue-slider>
          <div class="elem__graph" :style="{ marginBottom: compense_so3 }">
            <div
              class="elem__value t-black c-s-l"
              :style="{ height: h_s + 'px' }"
            >
              {{ apports.so3 | intLocal }}
            </div>
          </div>
          <div class="elem__label" v-html="$t('so3')"></div>
        </div>
        <!--so3-->
      </div>
      <!--slides-->
    </div>
    <!--graph__wrapper-->
    <v-layout row justify-between class="reco__wrapper">
      <v-flex xs-9 class="recos">
        <h2 class="form-title" style="margin-top:-0.8em" v-if="!noReco">
          {{
            !alternative
              ? $t("preco_formule_recommandee")
              : $t("preco_formule_alternative")
          }}
            <img src="img/badge_ab-small.svg" height="50px" />
        </h2>
        <div class="nowait" v-if="!wait">
          <produit
            :image="preco.produit_principal.nom"
            :dose="preco.produit_principal.dose"
            :compo="preco.produit_principal.formulation"
          ></produit>
          <produit
            :image="preco.produit_complement.nom"
            :dose="preco.produit_complement.dose"
            :compo="preco.produit_complement.formulation"
          ></produit>
          <p
            v-if="noReco"
            class="phrase"
            v-html="getPhraseId(preco.phrase)"
          ></p>
        </div>
        <div class="wait" v-if="wait">
          <p>{{ $t("preco_calcul") }}</p>
          <v-progress-linear
            :indeterminate="true"
            color="primary"
          ></v-progress-linear>
        </div>
      </v-flex>
      <v-flex xs-3 class="btns">
        <button
          id="btn-reset"
          @click="reset"
          :class="{ 'btn--label': true, invisible: !visible_reset }"
        >
          <v-icon large color="primary">refresh</v-icon>
          <span class="label-btn">{{ $t("preco_reset") }}</span>
        </button>
        <button
          id="btn-alternative"
          class="btn--label"
          @click="switchAlternative"
          v-if="!noReco && !noAlternative"
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 35 32"
            version="1.1"
            xml:space="preserve"
            style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"
          >
            <path
              d="M2.081,28.466l2.256,0.943l0,-15.209l-4.093,9.87c-0.684,1.71 0.139,3.681 1.837,4.396Zm32.844,-6.233l-8.354,-20.161c-0.703,-1.699 -2.679,-2.519 -4.379,-1.819l-12.414,5.137c-1.226,0.511 -2.04,1.702 -2.071,3.029c-0.017,0.463 0.069,0.923 0.251,1.348l8.355,20.162c0.517,1.243 1.734,2.061 3.081,2.071c0.446,0.001 0.888,-0.084 1.302,-0.25l12.398,-5.137c1.705,-0.698 2.534,-2.675 1.837,-4.38l-0.006,0Zm-23.833,-12.126c-0.924,0 -1.685,-0.761 -1.685,-1.685c0,-0.924 0.761,-1.685 1.685,-1.685c0.923,0 1.683,0.759 1.685,1.682c-0.002,0.925 -0.761,1.685 -1.685,1.688Zm-3.369,18.527c0.006,1.846 1.523,3.363 3.369,3.369l2.442,0l-5.811,-14.048l0,10.679Z"
              style="fill:#024ea1;fill-rule:nonzero;"
            />
          </svg>
          <span class="label-btn">{{
            alternative ? $t("preco_recommande") : $t("preco_alternative")
          }}</span>
        </button>
      </v-flex>
    </v-layout>
    <!-- /.reco__wrapper -->
    <v-layout class="nutriballs" v-if="!noReco && !wait">
      <v-flex style="width: 100%">
          <h2 class="form-title">
              {{ $t("preco_recap_apports")}} <span class="petit">({{ $t("in_unit") }}{{ $t("kgha") }})</span>
          </h2>
        <div class="besoins">
          <div class="ligne__elements">
            <div class="elem" transition="slide-x-transition">
              <img src="img/elem_k2o.svg" alt="" class="icn" /><span
                class="nead"
                >{{ this.apportsNutriments.k2o | intLocal }}</span
              >
            </div>
            <div class="elem" transition="slide-x-transition">
              <img src="img/elem_mgo.svg" alt="" class="icn" /><span
                class="nead"
                >{{ this.apportsNutriments.mgo | intLocal }}</span
              >
            </div>
            <div class="elem" transition="slide-x-transition">
              <img src="img/elem_so3.svg" alt="" class="icn" /><span
                class="nead"
                >{{ this.apportsNutriments.so3 | intLocal }}</span
              >
            </div>
          </div>
          <hr />
        </div>
      </v-flex>
    </v-layout>
    <v-layout class="justification" row>
      <v-flex style="width: 50px">
        <v-icon
          x-large
          :style="{ color: fuite ? c_fuite : c_pasFuite }"
          v-if="!noReco"
          >feedback</v-icon
        >
      </v-flex>
      <v-flex style="width: calc(100% - 50px);">
        <p class="pl-1 tal">
          <span
            v-if="!noReco"
            v-html="getPhraseId(preco.phrase)"
            class="phrase"
          ></span>
        </p>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 text-xs-center>
        <v-btn color="primary" class="btn-ks white--text" @click="goRepport" right>{{ $t("btn_repport") }}</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import Produit from "@/components/Produit.vue";
import router from "../router";

export default {
  //components: { VueSlider },
  name: "Recommandation",
  components: {
    VueSlider,
    Produit
  },
  data() {
    return {
      // pour l'affichage de l'attente
      wait: false,

      // model des slides
      m_k2o: 0,
      m_mgo: 0,
      m_so3: 0,

      // min & max des slides
      min_k2o: 0,
      min_mgo: 0,
      min_so3: 0,

      max_k2o: 0,
      max_mgo: 0,
      max_so3: 0,

      // hauteurs des slides
      h_k2o: 0,
      h_mgo: 0,
      h_so3: 0,

      // décalage vertical des slides
      decal_k2o: 0,
      decal_mgo: 1,
      decal_so3: 0,
      compense_k2o: 0,
      compense_mgo: 0,
      compense_so3: 0,

      // affichage ou non des slides
      enable_k2o: true,
      enable_mgo: true,
      enable_so3: true,
      // activation ou non des curseurs
      disable_k2o: false,
      disable_mgo: false,
      disable_so3: false,

      // valeurs initiales de la reco
      reco_k2o: 0,
      reco_mgo: 0,
      reco_so3: 0,

      // switch ab/non-ab
      ab: false,

      // switch alertnative
      alternative: false,

      //pas de recommandation (par défaut il y en a tjrs une)
      noReco: false,

      chlorureSeul: false, // ne sert que pour les tests
      sulfateSeul: false, // ne sert que pour les tests

      // couleurs des curseurs
      c_k20: "#009ee3",
      c_mgo: "#008c48",
      c_so3: "#ffcc00",

      // couleur icones
      c_fuite: "#c00000",
      c_pasFuite: "#76b043",

      // hauteur max des barres d'apports (px)
      hauteur_apports_max: 225,

      //hauteur max des sliders (px)
      hauteur_slides_max: 245, //anciennement 216 (120%)

      // options génériques pour les slides
      options_slides: {
        direction: "btt",
        lazy: true,
        width: 50,
        interval: 1,
        data: null,
        tooltip: "none",
        silent: true,
        adsorb: true
      },

      // affichage du badge ab
      visible_badge_ab: false,

      // phrase d'explication
      explication: null,

      //switch du reset
      visible_reset: false,

      // seuil de mouvement des slides
      seuil_mvt: 10,

      // seuil de valeur entre le min et max d'un slide
      seuil_val: 9,

      // aspect initial de la fuite (valeurs en dur dans le SVG)
      laFuite: {
        ry: 66,
        rx: 164,
        cy: 337.2
      }
    };
  },
  computed: {
    apports() {
      return this.$store.getters.getSynthesis;
    },

    apportsNutriments() {
      //if (this.noReco) return false;
      const n =
        this.preco.produit_principal.dose *
          (this.preco.produit_principal.formulation.n / 100) +
        this.preco.produit_complement.dose *
          (this.preco.produit_complement.formulation.n / 100);
      const p2o5 =
        this.preco.produit_principal.dose *
          (this.preco.produit_principal.formulation.p2o5 / 100) +
        this.preco.produit_complement.dose *
          (this.preco.produit_complement.formulation.p2o5 / 100);
      const mgo =
        this.preco.produit_principal.dose *
          (this.preco.produit_principal.formulation.mgo / 100) +
        this.preco.produit_complement.dose *
          (this.preco.produit_complement.formulation.mgo / 100);
      const so3 =
        this.preco.produit_principal.dose *
          (this.preco.produit_principal.formulation.so3 / 100) +
        this.preco.produit_complement.dose *
          (this.preco.produit_complement.formulation.so3 / 100);
      const k2o =
        this.preco.produit_principal.dose *
          (this.preco.produit_principal.formulation.k2o / 100) +
        this.preco.produit_complement.dose *
          (this.preco.produit_complement.formulation.k2o / 100);

      return { n: n, p2o5: p2o5, mgo: mgo, so3: so3, k2o: k2o };
    },

    neads() {
      return this.$store.getters.getNeads;
    },
    reco() {
      // if(laReco.lesRecommandations.chlorure.alternative === null && laReco.lesRecommandations.sulfate.alternative === null ) {
      //   this.noAlternative = true; // pas d'alternative
      // };
      return this.$store.getters.getRecommandation;
    },
    h_m() {
      if (this.neads.mgo !== 0) {
        // dans le cas où il n'y pas besoin d'un élément on ferme la barrique (validé par CM le 03/05/2019
        let hauteur = this.calc_height(this.apports.mgo, this.neads.mgo);
        if (isNaN(hauteur)) {
          return 0;
        } else {
          return hauteur > this.hauteur_apports_max
            ? this.hauteur_apports_max
            : hauteur;
        }
      } else {
        return this.hauteur_apports_max;
      }
    },
    h_k() {
      if (this.neads.k2o !== 0) {
        let hauteur = this.calc_height(this.apports.k2o, this.neads.k2o);
        if (isNaN(hauteur)) {
          return 0;
        } else {
          return hauteur > this.hauteur_apports_max
            ? this.hauteur_apports_max
            : hauteur;
        }
      } else {
        return this.hauteur_apports_max;
      }
    },
    h_s() {
      if (this.neads.so3 !== 0) {
        let hauteur = this.calc_height(this.apports.so3, this.neads.so3);
        if (isNaN(hauteur)) {
          return 0;
        } else {
          return hauteur > this.hauteur_apports_max
            ? this.hauteur_apports_max
            : hauteur;
        }
      } else {
        return this.hauteur_apports_max;
      }
    },
    fuite() {
      // matrice de vérité sur les slider qui sont actifs
      const table = [
        this.enable_k2o ? this.m_k2o < this.intVal(this.neads.k2o) : false,
        this.enable_mgo ? this.m_mgo < this.intVal(this.neads.mgo) : false,
        this.enable_so3 ? this.m_so3 < this.intVal(this.neads.so3) : false
      ];

      //console.log("Fuite ", table);
      return table.reduce((ret, val) => {
        return ret || val;
      });
    },
    fPotassium() {
      return this.$store.getters.getPotassium; // retourne soit "sulfate" soit "chlorure"
    },
    noAlternative() {
      const laPreco = this.reco.lesRecommandations;
      try {
        return (
          laPreco.chlorure.alternative.produit_principal.nom === "" &&
          laPreco.sulfate.alternative.produit_principal.nom === ""
        );
      } catch (e) {
        return true;
      }
    },
    // préco sert à l'affichage des produits recommandés, il sert à binder les composants "produit"
    preco() {
      const laPreco = this.reco.lesRecommandations;
      console.dir("laPreco", laPreco);
      const noPreco = {
        phrase: laPreco.phrase,
        produit_principal: {
          nom: "",
          ab: 0,
          dose: 0,
          formulation: {}
        },
        produit_complement: {
          nom: "",
          ab: 0,
          dose: 0,
          formulation: {}
        }
      };

      // console.log(laPreco);
      // console.log(noPreco);

      // cas particulier : tous les besoins sont couverts
      if (this.noRecommandations(laPreco)) {
        console.warn("Tous les besoins sont couverts");
        this.noReco = true;
        return noPreco;
      }
      try {
        // s'il n'y pas de choix final il n'y a pas d'alternative non plus et donc...
        if (
          laPreco.chlorure.choix_final.produit_principal.nom !== "" &&
          laPreco.sulfate.choix_final.produit_principal.nom !== ""
        ) {
          //this.noReco = false;
          if (!this.noAlternative) {
            // il y a des alternatives dans les deux propositions

            if (this.alternative) {
              // affichage de l'alternative
              if (this.fPotassium === "chlorure") {
                //this.lac("cas 1 chlorure");
                if (this.ab) {
                  // on force le sulfate car AB
                  // this.storeReco(laPreco.sulfate.alternative);
                  return laPreco.sulfate.alternative;
                } else {
                  // chlorure
                  // this.storeReco(laPreco.chlorure.alternative);
                  return laPreco.chlorure.alternative;
                }
              } else {
                // sulfate
                //this.lac("cas 1 sulfate");
                // this.storeReco(laPreco.sulfate.alternative);
                return laPreco.sulfate.alternative;
              }
            } else {
              // affichage de la formule recommandée
              if (this.fPotassium === "chlorure") {
                //this.lac("cas 2 chlorure");
                if (this.ab) {
                  // on force le sulfate car AB
                  // this.storeReco(laPreco.sulfate.choix_final);
                  return laPreco.sulfate.choix_final;
                } else {
                  // chlorure
                  // this.storeReco(laPreco.chlorure.choix_final);
                  return laPreco.chlorure.choix_final;
                }
              } else {
                // sulfate
                //this.lac("cas 2 sulfate");
                // this.storeReco(laPreco.sulfate.choix_final);
                return laPreco.sulfate.choix_final;
              }
            } // endif this.alternative
          } else {
            // il n'y a pas d'alternative
            if (this.fPotassium === "chlorure") {
              //this.lac("cas 3 chlorure");
              if (this.ab) {
                // on force le sulfate car AB
                // this.storeReco(laPreco.sulfate.choix_final);
                return laPreco.sulfate.choix_final;
              } else {
                // chlorure
                // this.storeReco(laPreco.chlorure.choix_final);
                return laPreco.chlorure.choix_final;
              }
            } else {
              // sulfate
              //this.lac("cas 3 sulfate");
              // this.storeReco(laPreco.sulfate.choix_final);
              return laPreco.sulfate.choix_final;
            }
          } // endif noAlternative
        } else {
          // il n'y a pas de recommandations (chlorure OU sulfate)

          if (
            laPreco.chlorure.choix_final.produit_principal.nom !== "" &&
            laPreco.sulfate.choix_final.produit_principal.nom === ""
          ) {
            // recommandation chlorure seule
            this.sulfateSeul = false;
            this.chlorureSeul = true;
            // console.info("Reco Chlorure non null et Sulfate null");
            this.noReco = false;
            if (!this.noAlternative) {
              if (this.alternative) {
                // formule alternative
                if (this.fPotassium === "chlorure") {
                  //this.lac("cas 4 chlorure");
                  if (this.ab) {
                    // on force le sulfate car AB -> mais de pas de sulfate donc pas de reco
                    this.noReco = true;
                    return noPreco;
                  } else {
                    // forme chlorure
                    // this.storeReco(laPreco.chlorure.alternative);
                    return laPreco.chlorure.alternative;
                  }
                } else {
                  // forme sulfate -> pas de sulfate
                  //this.lac("cas 4 sulfate");
                  return noPreco;
                }
              } else {
                // formule recommandée
                if (this.fPotassium === "chlorure") {
                  //this.lac("cas 5 chlorure");
                  if (this.ab) {
                    // on force le sulfate car AB -> mais de pas de sulfate donc pas de reco
                    this.noReco = true;
                    return noPreco;
                  } else {
                    // chlorure
                    // this.storeReco(laPreco.chlorure.choix_final);
                    return laPreco.chlorure.choix_final;
                  }
                } else {
                  //this.lac("cas 5 sulfate");
                  // forme sulfate
                  return noPreco;
                }
              } // endif this.alternative
            } else {
              // il n'y a pas d'alternative
              if (this.fPotassium === "chlorure") {
                //this.lac("cas 6 chlorure");
                if (this.ab) {
                  // on force le sulfate car AB
                  return noPreco;
                } else {
                  // forme chlorure
                  // this.storeReco(laPreco.chlorure.choix_final);
                  return laPreco.chlorure.choix_final;
                }
              } else {
                // forme sulfate
                //this.lac("cas 6 sulfate");
                return noPreco;
              }
            } // endif noAlternative
          } // endif chlorure non-null et sulfate null

          if (
            laPreco.chlorure.choix_final.produit_principal.nom === "" &&
            laPreco.sulfate.choix_final.produit_principal.nom !== ""
          ) {
            this.chlorureSeul = false;
            this.sulfateSeul = true;
            // console.info("Reco Chlorure null et Sulfate non null");
            this.noReco = false;
            if (!this.noAlternative) {
              if (this.alternative) {
                // formule alternative
                // this.storeReco(laPreco.sulfate.alternative);
                return laPreco.sulfate.alternative;
              } else {
                // formule recommandée
                // this.storeReco(laPreco.sulfate.choix_final);
                return laPreco.sulfate.choix_final;
              } // endif this.alternative
            } else {
              // il n'y a pas d'alternative
              // this.storeReco(laPreco.sulfate.choix_final);
              return laPreco.sulfate.choix_final;
            } // endif noAlternative
          } // endif chlorure null et sulfate non-null
        } // endif
      } catch (e) {
        console.warn("Pas de recommandation");
        this.noReco = true;
        return noPreco;
      }
    },
    precoAb() {
      // calcul si la formule fournie est utilisable en AB
      let principal = false;
      let complement = false;

      if (!this.noReco) {
        if (
          this.preco.produit_principal.ab === 1 ||
          this.preco.produit_principal.dose === 0
        ) {
          principal = true;
        }
        if (this.preco.produit_complement.ab === 1) {
          complement = true;
        }

        console.log("AB1", principal);
        console.log("AB2", complement);

        this.ab = principal && complement;
        return principal && complement;
      } else {
        return false;
      }
    }
  },
  methods: {
    lac(value) {
      console.log(value);
    },
    intVal(value) {
      return Math.abs(Math.round(parseFloat(value)));
    },
    intValSup(value) {
      return Math.abs(Math.ceil(parseFloat(value)));
    },
    intSup(value) {
      return (value < 0) ? 0 : (Math.round(parseFloat(value)));
    },
    calc_height(give, nead) {
      return Math.ceil((give / nead) * this.hauteur_apports_max);
    },
    slideChange() {
      const fuite = this.fuite;
      console.info("Valeur changée | ", fuite);
      this.visible_reset = true;

      if (fuite) {
        SVG.get("fuite")
          .animate(500, "<", 300)
          .cy(352)
          .radius(200, 100);
      } else {
        SVG.get("fuite")
          .animate(250, "<", 300)
          .cy(this.laFuite.cy)
          .radius(this.laFuite.rx, this.laFuite.ry);
      }

      // TODO: lancement cycle d'attente

      this.wait = true;

      this.$store
        .dispatch("motor", {
          apportK2O_100: this.reco_k2o,
          apportMgO_100: this.reco_mgo,
          apportSO3_100: this.reco_so3,
          apportK2O: this.m_k2o - this.apports.k2o,
          apportMgO: this.m_mgo - this.apports.mgo,
          apportSO3: this.m_so3 - this.apports.so3
        })
        .then(
          // TODO: masquer le cycle d'attente
          () => {
            this.wait = false;
          }
        );
    },
    getPhraseId(id) {
      console.log("id phrase ", id);
      if (this.$store.getters.getPhraseId(id) === false) {
        return (
          "<strong style='color:red'>" +
          this.$i18n.t("err_phrase") +
          "</strong>"
        );
      } else {
        return this.$store.getters.getPhraseId(id);
      }
    },
    reset() {
      console.info("RESET !!!");
      // on recalcule les valeurs pour les curseurs
      this.m_k2o = this.intVal(this.reco_k2o + this.apports.k2o);
      // this.m_mgo = this.intVal(this.reco_mgo + this.apports.mgo);
      // this.m_mgo =
      //   this.intVal(this.reco.mgo + this.apports.mgo) > this.neads.mgo
      //     ? this.intVal(this.neads.mgo)
      //     : this.intVal(this.reco.mgo + this.apports.mgo);
      this.m_mgo = this.intVal(this.reco.mgo + this.apports.mgo);
      this.m_so3 = this.intVal(this.reco_so3 + this.apports.so3);

      if (this.m_k2o > this.max_k2o) {
        this.m_k2o = this.max_k2o; //- this.reco_k2o;
      }

      if (this.m_mgo > this.max_mgo) {
        this.m_mgo = this.max_mgo; //- this.reco_mgo;
      }

      if (this.m_so3 > this.max_so3) {
        this.m_so3 = this.max_so3; //- this.reco_so3;
      }

      // on résorbe la fuite
      SVG.get("fuite")
        .animate(250, "<", 300)
        .cy(this.laFuite.cy)
        .radius(this.laFuite.rx, this.laFuite.ry);

      this.visible_reset = false;

      // on lance l'animation d'attente
      this.wait = true;
      // le switch AB est réunitialisé
      this.ab = false;
      // reset du flag noReco
      this.noReco = false;

      // et on rappel le moteur avec les valeurs d'origine
      this.$store
        .dispatch("motor", {
          apportK2O_100: this.reco_k2o,
          apportMgO_100: this.reco_mgo,
          apportSO3_100: this.reco_so3,
          apportK2O: this.reco_k2o,
          apportMgO: this.reco_mgo,
          apportSO3: this.reco_so3
        })
        .then(() => {
          // le moteur à répondu, on retire l'animation d'attente
          this.wait = false;
        });
    },
    switchAb(value) {
      this.ab = value;
      // console.info("Changement AB");
    },
    switchAlternative() {
      this.alternative = !this.alternative;
    },

    goRepport() {
      this.storeReco(); // stockage des données de la reco

      this.$store.dispatch("updateRoutes", this.$router.currentRoute.path).then(
        () => {
          this.$router.push({ path: "repport" }); // on change de page
        },
        () => {
          console.error("Erreud de routage ");
        }
      );
    },

    storeReco() {
      let apports_nutriments = this.apportsNutriments,
        reco = this.preco,
        ab = this.ab,
        valCurseurs = {"k2o":this.m_k2o, "mgo":this.m_mgo, "so3":this.m_so3};

      // console.log(this.preco);

      this.$store
        .dispatch("storeReco", { apports_nutriments, reco, ab, valCurseurs })
        .then(console.info("Stockage de la reco effectué"));
    },

    noRecommandations(laPreco) {
      console.log("laPreco", laPreco);
        if (
            laPreco.chlorure.choix_final === null &&
            laPreco.sulfate.choix_final === null
        ) {
            console.warn("les choix finaux sont null");
            return false;
        } else {
            //return (
            //  laPreco.chlorure.choix_final.produit_principal.nom === "" &&
            //  laPreco.sulfate.choix_final.produit_principal.nom === ""
            //);
            var precoChlorure = false;
            var precoSulfate = false;
            if (laPreco.chlorure.choix_final != null) {
                if (laPreco.chlorure.choix_final.produit_principal != null) {
                    if (laPreco.chlorure.choix_final.produit_principal.nom != "") {
                        precoChlorure = true;
                    }
                }
            }
            if (laPreco.sulfate.choix_final != null) {
                if (laPreco.sulfate.choix_final.produit_principal != null) {
                    if (laPreco.sulfate.choix_final.produit_principal.nom != "") {
                        precoSulfate = true;
                    }
                }
            }
            console.log("precoChlorure && precoSulfate", [precoChlorure, precoSulfate]);
            return !(precoChlorure || precoSulfate);
        }
    }
  },
  created() {
    try {
      // sotckage des valeurs initiales de la recommandation (pour le reset)
      this.reco_k2o = this.reco.k2o;
      this.reco_mgo = this.reco.mgo;
      this.reco_so3 = this.reco.so3;

      // si les besoins sont à 0 ou si les besoins sont >= reco_120% on désactive le slider
      if (this.apports.k2o >= this.reco.k2o_120 || this.neads.k2o === 0) {
        this.enable_k2o = false;
      }
      if (this.apports.mgo >= this.reco.mgo_120 || this.neads.mgo === 0) {
        this.enable_mgo = false;
      }
      if (this.apports.so3 >= this.reco.so3_120 || this.neads.so3 === 0) {
        this.enable_so3 = false;
      }

      //console.log([this.enable_k2o, this.enable_mgo, this.enable_so3]);

      // calcul des valeurs mini des sliders et valeurs par defaut des curseurs
      // au chargement de la page
      if (this.apports.k2o <= this.neads.k2o) {
        this.m_k2o = this.reco.k2o + this.apports.k2o;
        this.min_k2o = this.intVal(this.apports.k2o);
      }
      // Dans le cas du mgo, celui-ci peut avoir un apport supérieur au besoin en fonction du pH (cf. store.js l:239)
      // if (this.apports.mgo <= this.neads.mgo) {
      //   // donc pour éviter que le slider déconne on plafone la valeur à celle des besoins
      //   this.m_mgo =
      //     this.intVal(this.reco.mgo + this.apports.mgo) > this.neads.mgo
      //       ? this.intVal(this.neads.mgo)
      //       : this.intVal(this.reco.mgo + this.apports.mgo);
      //   this.min_mgo = this.intVal(this.apports.mgo);
      // }
      if (this.apports.mgo <= this.neads.mgo) {
        this.m_mgo = this.intVal(this.reco.mgo + this.apports.mgo);
        this.min_mgo = this.intVal(this.apports.mgo);
      }
      if (this.apports.so3 <= this.neads.so3) {
        this.m_so3 = this.intVal(this.reco.so3 + this.apports.so3);
        this.min_so3 = this.intVal(this.apports.so3);
      }

      // calcul des valeurs maxi des sliders
      this.max_k2o = this.intValSup(this.reco.k2o_max);
      this.max_mgo = this.intValSup(this.reco.mgo_max);
      this.max_so3 = this.intValSup(this.reco.so3_max);

      // calcul des hauteurs des slides et décalages
      this.decal_k2o = this.h_k;
      this.decal_mgo = this.h_m;
      this.decal_so3 = this.h_s;
      this.h_k2o = this.hauteur_slides_max - this.decal_k2o;
      this.h_mgo = this.hauteur_slides_max - this.decal_mgo; // + 40; // compensation mystérieuse
      this.h_so3 = this.hauteur_slides_max - this.decal_so3; // + 10; // compensation mystérieuse
      // si l'écart sur lequelle l'utilisateur peut agir est inf au seuil, le slide est désactivé

      if (this.m_k2o > this.max_k2o) {
        this.m_k2o = this.max_k2o;
      }

      if (this.m_mgo > this.max_mgo) {
        this.m_mgo = this.max_mgo;
      }

      if (this.m_so3 > this.max_so3) {
        this.m_so3 = this.max_so3;
      }

      // if (this.max_k2o - this.min_k2o <= this.seuil_val) {
      //   this.disable_k2o = true;
      // }
      // if (this.max_mgo - this.min_mgo <= this.seuil_val) {
      //   this.disable_mgo = true;
      // }
      // if (this.max_so3 - this.min_so3 <= this.seuil_val) {
      //   this.disable_so3 = true;
      // }

      // si le slide fait moins de XX px de haut, il est désactivé
      // if (this.hauteur_apports_max - this.decal_k2o < this.seuil_mvt) {
      //   this.enable_k2o = false;
      //   this.compense_k2o = -this.h_k2o; // compensation de la hauteur du slide désactivé
      // }
      // if (this.hauteur_apports_max - this.decal_mgo < this.seuil_mvt) {
      //   this.enable_mgo = false;
      //   this.compense_mgo = -this.h_mgo; // compensation de la hauteur du slide désactivé
      // }
      // if (this.hauteur_apports_max - this.decal_so3 < this.seuil_mvt) {
      //   this.enable_so3 = false;
      //   this.compense_so3 = -this.h_so3; // compensation de la hauteur du slide désactivé
      // }
    } catch (e) {
      console.error("Retour à l'accueil");
      router.push("home");
    }
  } // Created
};
</script>

<style scoped lang="scss">
$c-s: #ffcc00;
$c-m: #008c48;
$c-k: #009ee3;

.switch2e {
  &.v-input--switch {
    /*padding-top: 0;*/
    height: 2em;
    margin-top: 0;
  }
}

.k2o,
.mgo,
.so3 {
  position: relative;
  height: 220px;
  width: 50px;
}

.graph__wrapper {
  position: relative;
  max-width: 450px;
  height: 395px;
  margin: 0 auto;
}

.graphSVG {
  position: absolute;
  height: 400px;
  width: 400px;
  top: -24px;
  left: -30px;

  //@media screen and (min-width: 450px) {
  //  left: 0;
  //}
}

.elem__label {
  text-align: center;
  font-size: 1.15em;
  position: absolute;
  bottom: -24px;
  width: 100%;
  z-index: 10;
}

.elem__graph {
  height: auto;
  position: absolute;
  width: 100%;
  bottom: 0;
}

#labelNeads,
#labelApportsM,
#labelContribution {
  position: absolute;
  left: 2em;
  line-height: 1;
  font-size: 0.95em;
}

#labelNeads {
  top: 154px;
}

#labelApportsM {
  top: 220px;
}

.elem__neads {
  position: absolute;
  top: 158px;
  left: 131px;
  width: 150px;

  & > * {
    position: absolute;
    top: 0;
    width: 50px;
    text-align: center;
  }

  & > *:nth-child(1) {
    left: -1;
  }
  & > *:nth-child(2) {
    left: 50px;
  }
  & > *:nth-child(3) {
    left: 100px;
  }
}

.vue-slider {
  position: absolute;
}

.slides {
  position: absolute;
  bottom: 54px;
  left: 101px;
  display: flex;
  flex-flow: row nowrap;
  //justify-content: space-between;
}

.curseur_value {
  position: relative;
}

.value_elem {
  position: absolute;
  left: -12px;
  top: 10px;
  font-size: 0.8em;

  .mgo &,
  .k2o & {
    color: #fff;
  }
}

.curseur {
  margin-left: -18px;
  margin-top: -12px;
  fill: #fff;
  stroke-width: 15px;
  stroke: transparent;
  width: 18px;
  position: relative;
  top: 24px;
  left: 27px;
      
  &:hover {
    cursor: grab;
  }

  /*.k2o & {
    stroke: $c-k;
  }

  .mgo & {
     stroke: $c-m;
  }*/

  .so3 & {
    /*stroke: $c-s;*/
    fill: #000;
  }
}

.phrase {
  font-size: 1.15em;
  line-height: 1;
  font-weight: 600;
  color: #444;
}

#btn-alternative {
  width: 6em;
  svg {
    height: 32px;
  }
  &:focus {
    outline: none;
  }
}

#btn-reset {
  width: 6em;
  .label-btn {
    margin-top: -0.55em;
  }
}

#badgeAb {
  position: absolute;
  right: -338px;
  bottom: 30px;
}

.btns {
  position: relative;
  display: flex;
  flex-flow: column wrap;

  &:focus {
    outline: none;
  }

  & > * {
    margin-bottom: 0.5em;
  }
}

.btn--label {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;

  .label-btn {
    font-size: 0.8em;
    text-align: center;
  }
}

.besoins {
  margin-top: 0;
}
</style>
